import React from 'react';
import ProductBg from "../assets/productBg.png";

import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from "@mui/material";



const customStyle = makeStyles({
  bodyBgColor: {
    backgroundColor: "white",
  },


  aboutUsText: {},
  demoButton: {
    backgroundColor: "#FFFFFF !important",
    color: "#31B9B5 !important",
    fontWeight: "bold !important",
    "&:hover": {
      backgroundColor: "#f7f4f4 !important",
      color: "#31B9B5 !important",
      fontWeight: "bold !important",
    },
  },
});

const Product = () => {
  const classes = customStyle(); // Call makeStyles function to generate the styles

  return (
    <Box  className={classes.bodyBgColor} marginTop={5} >
    <Container maxWidth="xl" className="productContainer" >
        <section id="product">
           
              <Grid
                container
                minHeight="50vh"
                alignItems="center"
                pt={{ xs: 4, md: 5 }}
              >
                <Grid item xs={12} md={6}>
                  <Box my={{ md: "none", xs: 5 }}>
                    <img src={ProductBg} width={"100%"} />
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}

                  

                  textAlign={{ xs: "center", md: "start" }}
                  // px={{ xs: 2 }}
                  p={{ xs: 2, md: 6 }}
                >

<Box  justifyContent="flex-end">
                  <Typography
                    mb={2}
                    variant={"h6"}
                    fontWeight={700}
                    style={{
                      fontSize: "24px",
                      lineHeight: "36px",
                      textAlign: "left",
                      fontFamily: "Inter"
                    }}
                  >
                    Experience the state-of-art mortgage application with new age digital genie
                    for Mortgage universe -
                    <Typography
                      variant="h3"
                      component={"span"}
                      color="primary"
                      marginLeft={"3px"}
                      style={{
                        fontSize: "24px",
                        lineHeight: "36px",
                        textAlign: "left",
                        fontFamily: "Inter",
                        fontWeight: 700
                      }}
                    >
                      CliqLoan
                    </Typography>

                  </Typography>
                  <Typography
                    variant="body1"
                    mb={5}
                    textAlign="justify"
                    style={{
                      fontFamily: "DM Sans",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "26.88px",
                      textAlign: "justify"
                    }}
                  >
                    CliQloan offers a best-in-class application experience, as well as a strong
                    set of automation, customization, and branding capabilities. Our Motto is to
                    give customers more than what they deserve. Good communication is essential
                    for a great borrowing experience. We have a plethora of readily configurable
                    and automatic communication techniques that ensure all customers & other
                    stakeholders receive the information they require, when and wherever they
                    require it.
                  </Typography>
                  </Box>
                </Grid>
              </Grid>
        </section>
  
  
    </Container>
    </Box>
  );
};

export default Product;
